module.exports = __webpack_public_path__ + "img/damage-other.e2444223.png";